class VariantFree extends HTMLElement {
  constructor() {
    super();

    this.sectionId = this.dataset.section;
    this.temporaryHandle = this.dataset.temporaryHandle;
    this.temporaryVariant = parseInt(this.dataset.temporaryVariant);
    this.variant = this.querySelector('[data-variant-free]');
    this.content = this.querySelector('[data-variant-content]');
    this.radio = this.querySelectorAll('[data-variant-radio]');
    this.mainProduct = document.getElementById(`MainProduct-${this.sectionId}`);
    this.form = document.getElementById(`product-form-${this.sectionId}`);
    this.media = document.getElementById(`MediaGallery-${this.sectionId}`);
    this.addButtonSubmit = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.radio.forEach((radio) => radio.addEventListener('click', this.onRadioClick.bind(this)));
    this.productRechargeElement();
    if (this.temporaryHandle != '') {
      this.loadProduct();
    }
  }

  onRadioClick(event) {
    const handle = event.target.value;
    const currentHandle = this.variant.dataset.variantFree;
    if (handle != currentHandle) {
      this.content.innerHTML = '';
      this.variant.querySelector('.loading__spinner').classList.remove('hidden');
      this.variant.dataset.variantFree = handle;
      fetch(`/products/${handle}?view=brow-sheets-v1.1`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const mediaSource = html.querySelector('media-gallery');
          const descriptionSource = html.querySelector('.product__description');
          const variantSource = html.querySelector('[data-product-variant-picker]');

          if (mediaSource) this.renderMedia(mediaSource);
          if (descriptionSource) this.renderDescription(descriptionSource);
          if (variantSource) this.renderVariant(variantSource);
          if (this.addButtonSubmit) this.addButtonSubmit.classList.remove('product-form__submit--enabel-tooltip');
        });
      }
  }

  loadProduct() {
    this.content.innerHTML = '';
    this.variant.querySelector('.loading__spinner').classList.remove('hidden');
    this.variant.dataset.variantFree = this.temporaryHandle;
    fetch(`/products/${this.temporaryHandle}?view=brow-sheets-v1.1`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const mediaSource = html.querySelector('media-gallery');
        const descriptionSource = html.querySelector('.product__description');
        const variantSource = html.querySelector('[data-product-variant-picker]');

        if (mediaSource) this.renderMedia(mediaSource);
        if (descriptionSource) this.renderDescription(descriptionSource);
        if (variantSource) this.renderVariant(variantSource);
        if (this.addButtonSubmit) this.addButtonSubmit.classList.remove('product-form__submit--enabel-tooltip');
      });
  }

  renderVariant(variantSource) {
    variantSource.querySelector('variant-colors').dataset.section = this.sectionId;
    variantSource.querySelector('variant-colors').setAttribute('data-update-url', 'false');
    variantSource.querySelector('variant-colors').id = `variant-colors-${this.sectionId}`;
    variantSource.querySelector('.variant__dropdown-image').id = `Variant-Image-${this.sectionId}`;
    const variantJson = JSON.parse(variantSource.querySelector('[type="application/json"]').textContent);
    const selectedOptionOneVariants = variantJson.filter(
      (variant) => variant.id == this.temporaryVariant
    );

    if (this.form.querySelector('input[name="selling_plan"]')) {
      this.updateSellingPlan(variantJson);
    }
    
    this.content.innerHTML = variantSource.innerHTML;
    const variantColors = this.content.querySelector('variant-colors');

    if (this.temporaryVariant == '') {
      variantColors.resetVariant();
    } else {
      variantColors.resetVariantTemporary(selectedOptionOneVariants[0]['title']);
    }

    if (this.form.querySelector('.product-form__submit--tooltip')) {
      this.form.querySelector('.product-form__submit--tooltip').remove();
    }
    
    this.variant.querySelector('.loading__spinner').classList.add('hidden');
  }

  updateSellingPlan(variantSource) {
    const sellingPlan = variantSource[0]['selling_plan_allocations'][0]['selling_plan_id'];
    if (document.querySelector('input[name="purchaseOption"]:checked').value == 'subscription') {
      this.form.querySelector('input[name="selling_plan"]').value = sellingPlan;
    } else {
      this.form.querySelector('input[name="selling_plan"]').value = '';
    }
  }

  renderDescription(descriptionSource) {
    const description = this.mainProduct.querySelector('.product__description');
    description.innerHTML = descriptionSource.innerHTML;
  }

  renderMedia(mediaSource) {
    const sectionId = mediaSource.id.replace('MediaGallery-','');
    this.media.innerHTML = mediaSource.innerHTML.replaceAll(sectionId, this.sectionId);
    const mediaGallery = document.querySelector('media-gallery');
    mediaGallery.resetMediaGallery();
  }

  productRechargeElement() {
    /* product Recharge */
    const productRechargeElement = document.querySelector('[data-product-recharge]');
    if (productRechargeElement && productRechargeElement.dataset.productRecharge == 'true') {
      productRecharge(productRechargeElement);
    }
  }
  
}

customElements.define('variant-free', VariantFree);
